<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<action-form
				:action-id="id"
				:code-project="codeProject"
			/>
		</action-sidebar>
	</div>
</template>

<script>
	import actionForm from '@/components/actions/action-form';
	import actionSidebar from '@/components/shared/action-sidebar';

	function closeModal() {
		this.goTo('page-action');
	}

	function title() {
		const action = 'Acción';
		return this.id ? `Editar ${action}` : `Nueva ${action}`;
	}

	export default {
		name: 'page-action-new',
		components: {
			actionForm,
			actionSidebar,
		},
		computed: {
			title,
		},
		methods: {
			closeModal,
		},
		props: {
			id: {
				type: [Number, String],
			},
			codeProject: {
				type: String,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/actions/page-action-new.vue